import { PROXIMITY } from '@helpers/javascript/config/CONSTANTS'

// Dispatch
export const stopWorkorderAction = (id, proximityStatus) => dispatch =>
  dispatch({
    type:    WORKORDER_STOP.ACTION,
    payload: { id, proximity_stop_status: proximityStatus }
  })


// Reducer response
export const WORKORDER_STOP = {
  ACTION: 'WORKORDER_STOP',

  call: ({ state, id, proximityStatus }) => {
    const workorder = state.items.find(wo => wo.id === id)

    let pausedInterval, pausedTotal

    if (workorder.paused) {
      pausedInterval = parseInt((new Date - new Date(workorder.start_pause)) / 60000)
      pausedTotal    = workorder.paused_time + pausedInterval
    } else {
      pausedTotal    = workorder.paused_time
    }

    const editedWorkorder = {
      ...workorder,
      date_done:             new Date,
      paused:                false,
      paused_time:           pausedTotal,
      synced:                false,
      loading:               false,
      proximity_stop:        proximityStatus === PROXIMITY.CONFIRMED,
      proximity_stop_status: proximityStatus
    }

    const workorders = state.items.map(wo => wo.id === id ? editedWorkorder : wo)
    return { ...state, items: workorders }
  }
}
